import { PremiumRoutes } from "@/premium/routes";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AlertProvider } from "capitalrx-components-2.0/lib/general";
import { OverlayContainer } from "capitalrx-components-2.0/lib/general/Overlay";
import { FC } from "react";

export const PremiumRoot: FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AlertProvider>
        <OverlayContainer>
          <PremiumRoutes />
        </OverlayContainer>
      </AlertProvider>
    </QueryClientProvider>
  );
};
